import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Box } from '@mui/material';
import {
  secondaryText,
  mainText,
  accordionSummary,
  mask,
  summaryInfo,
  cardWithSummary,
  headerWithBalans, statusBox
} from './CardSummary.sx';
import YeloCardIcon from 'app/components/Icons/YeloCardIcon';
import LockIcon from 'app/components/Icons/LockIcon';
import { green, yellow } from 'app/components/ThemeProvider/colors';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';

interface SummaryProps {
  headerText: string;
  accountText: string;
  amount: string;
  open?: boolean;
  setOpen?: (arg?: boolean) => void;
  status?: any;
  currency?: any;
  img?: any;
}
const CardSummary = (props: SummaryProps) => {
  const { headerText, accountText, amount, status, open, currency, img } = props;

  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={
          accordionSummary
          // {
          // ...

          // '& .MuiAccordionSummary-expandIconWrapper > .MuiSvgIcon-root > path': {
          //   fill: status.value !== 'closed' ? '#14191F' : '#14191F38',
          // },
          // }
        }
      >
        <Box sx={cardWithSummary}>
          <Box sx={{ width: '52px', height: '32.5px', borderRadius: '8px' }}>
            {(status === 'BLOCKED' || status === 'BANKBLOCKED') && (
              <Box sx={mask}>
                <LockIcon color={'secondary'} sx={{ width: '18px', height: '21px' }} />
              </Box>
            )}
            <YeloCardIcon />
            {/*<img src={img} alt="" />*/}
          </Box>
          <Box sx={summaryInfo}>
              <Box sx={headerWithBalans}>
                <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                  <Typography sx={mainText}>{headerText}</Typography>
                  <Typography sx={secondaryText}>{accountText}</Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                  {!open && (
                      <>
                        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
                          {amount} {useCurrencySymbol(currency)}
                        </Typography>
                        <Typography sx={secondaryText}>Balans</Typography>
                      </>
                  )}
                </Box>
              </Box>
          </Box>
        </Box>
        <Box sx={statusBox}>
          <Box sx={{display: 'flex',alignItems: 'center',gap: '12px'}}>
            {status === 'ACTIVE' ? (
                <>
                  <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>
                  <Typography>Aktiv</Typography>
                </>
            ) : (
                (status === 'BLOCKED' || status === 'BANKBLOCKED') && (
                    <>
                      <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>
                      <Typography>Bloklaşdırılmış</Typography>
                    </>
                )
            )}
          </Box>
        </Box>
      </AccordionSummary>
    </>
  );
};

export default CardSummary;